/**
 * Lightweight analytics shim for the pricing page, mapping the handful of
 * events the original beancount-cms fired (`acquisition.pricingView`,
 * `revenue.checkoutStart`, CTA clicks) onto this site's gtag instance. No-ops
 * when gtag is unavailable (SSR, or analytics disabled).
 */

import { emitGaEvent } from "@/lib/ga-event";

/** Pricing page viewed (acquisition lead). */
export function trackPricingView(source: string): void {
  emitGaEvent("lead_pricing", { event_category: "acquisition", source });
}

/** A pricing CTA was clicked (e.g. start_for_free, contact_enterprise). */
export function trackCtaClick(label: string): void {
  emitGaEvent("cta_click", {
    event_category: "acquisition",
    event_label: label,
    source: "pricing_table",
  });
}

/** A paid-tier checkout was started (revenue funnel). */
export function trackCheckoutStart(value: number, currency = "USD"): void {
  emitGaEvent("checkout_start", { event_category: "revenue", value, currency });
}
